import { useContext } from "react";
import { ActionType } from "../actions";
import { DonationPageStateContext, DonorType } from "../state";
import { allowedDonorTypes, donorTypeLabels } from "../donor-type";
import "./pac-donation-toggle.css";

export const PacDonationToggle = () => {
    const { state, dispatch } = useContext(DonationPageStateContext);

    const toggleDonorType = (donorType: DonorType) => {
        dispatch({ type: ActionType.UpdateDonorType, donorType: donorType })
    }

    // Individual is always on offer; the rest come from what the page allows.
    const donorTypes: DonorType[] = ["Individual", ...allowedDonorTypes(state.configuration.pacDonation)];

    // Nothing to choose between.
    if (donorTypes.length < 2) {
        return null;
    }

    return (
        <section className="pac-donation-toggle">
            <label>Making donation as:</label>
            {donorTypes.map(donorType =>
                <label key={donorType}>
                    <input type="radio"
                        name="donortype"
                        value={donorType}
                        checked={state.donorType == donorType}
                        onChange={() => toggleDonorType(donorType)} />
                    {donorTypeLabels[donorType]}
                </label>
            )}
        </section>
    );
}
